import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  VIEW_BESIDE_PREVIEW_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "../../../styles/Styles";
import {Typography} from "@material-ui/core";
import Space from "../commons/Space";
import {FormattedMessage} from "react-intl";
import {ColorActivityForm} from "../../../styles/Colors";
import ActivityPreviewView from "../commons/ActivityPreviewView";

const useStyles = (theme) => ({
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    width: '100%',
    height: '100%',
  },
  boxDescription: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: BORDER_RADIUS,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
    width: '100%',
    marginBottom: FIELD_SPACE
  }
});

class ManageActivityPreview extends React.Component {

  constructor(props) {
    super(props);

    const type = this.props.activityData.type;
    this.sectionDescription = {id: 1, labelId: `activity.manage.${type}.title`, expand: true, expandAlways: true};
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    return {
    };
  }

  render() {
    const {activityData, classes, isXS} = this.props;
    const type = activityData.type;
    // const previewUrl = `${APP_BASE_URI}/public/images/activityVideo/vidPreview-${type}.mp4`;
    // const previewUrl = `${APP_BASE_URI}/public/images/activityVideo/vidPreview.mp4`;
    const previewUrl = null;
    const titleId = `activity.manage.${type}.title`;
    const descriptionId = `activity.manage.${type}.description`;
    const winnerInfoId = `activity.manage.${type}.winInfo`;

    // const hideWinInfo = type === constants.activity.types.SMART_AD
    //   || type === constants.activity.types.QUESTION
    //   || type === constants.activity.types.VISITOR_OPINION;
    const hideWinInfo = true;

    return (
        <div className={classes.flexColumn}>
          <div className={classes.viewRowFullWidthNoCenter} style={{justifyContent: 'center', flexWrap: 'wrap'}}>
          {previewUrl ?
            <Space verticalSpace={!isXS ? 4 : 0} />
            : null
          }
          <div style={{width: '100%', maxWidth: VIEW_BESIDE_PREVIEW_MAX_WIDTH, marginBottom: 1.2 * FIELD_SPACE}}>
            <div className={classes.boxDescription}>
              <div className={classes.flexColumn} style={{padding: 16, paddingTop: 8}}>
                <Typography variant={'h6'} color={'primary'} align={'center'} className={classes.typoMedium}>
                  <FormattedMessage id={this.sectionDescription.labelId} />
                </Typography>
                <Typography align={'center'} variant={'body1'} color={'textPrimary'}>
                  {<FormattedMessage id={descriptionId}/>}
                </Typography>
                {!hideWinInfo ?
                  <Space horizontalSpace={1.5} />
                  : null
                }
                {!hideWinInfo ?
                  <Typography align={'center'} variant={'body1'} color={'textPrimary'}>
                    {<FormattedMessage id={winnerInfoId}/>}
                  </Typography>
                  : null
                }
              </div>
            </div>
          </div>
          {previewUrl ?
            <Space verticalSpace={!isXS ? 4 : 0} />
            : null
          }
          {previewUrl ?
            <ActivityPreviewView textId={'activity.preview'}>
              <video controls autoPlay className={classes.videoPreview}>
                <source src={previewUrl} type="video/mp4" />
              </video>
            </ActivityPreviewView>
            : null
          }
        </div>
      </div>
    )
  }

}

ManageActivityPreview.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityPreview.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
  ])(ManageActivityPreview))
);
